import { Directive, ElementRef, Input } from "@angular/core";

@Directive({
  selector: '[mrt-side-nav-item]'
})
export class SideNavItemDirective {
  @Input() key: string;
  @Input() index: number;

  constructor( public element: ElementRef<HTMLElement> ) {

  }
}
